import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { WhileWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  getColumnReferencesFromString,
  getNamedInputReferencesFromString,
  getParamReferencesFromString,
  getTagReferencesFromString,
} from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('While')
export class WhileNode extends BaseWorkflowNode<WhileWorkflowNode> {
  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return getColumnReferencesFromString(this.node.condition, schemas);
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return getTagReferencesFromString(this.node.condition, schemas);
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return getParamReferencesFromString(this.node.condition, schemas, connectors);
  }

  getNamedInputReferences(
    schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return getNamedInputReferencesFromString(this.node.condition, schemas);
  }
}
